import type { FC } from 'react';
import { TextInput } from '@/lib/ui/TextInput';
import { observer } from 'mobx-react-lite';
import type { AnswersViewProps } from '../AnswersView';
import type { TextModel } from './TextModel';
import { MAX_USER_COMMENT_LENGTH } from '@/survey/logic/QuestionModel/constants';

export const Text: FC<AnswersViewProps<TextModel>> = observer(({ questionModel }) => {
  const { question, userComment, disabled, validationErrors } = questionModel;

  return (
    <TextInput
      value={userComment}
      onChange={(str) => questionModel.set_userComment(str)}
      placeholder={question.comment_hint}
      disabled={disabled}
      hasWarning={validationErrors.emptyUserCommentError}
      maxLength={MAX_USER_COMMENT_LENGTH}
    />
  );
});
